import React from 'react'
import Dashboard from '../../dashboard/index'
import ValidateView from './page'

const Validate = () => {
  return <Dashboard component={<ValidateView />} />
}

export default Validate
